import {Init} from '@/core/Init'

class UserData {

    /**
     *
     */
    constructor() {

    }


    /**
     * see if we have a design already saved under this name
     *
     */
    public static submit = (): void => {

        let data: any = {};
        data.auth_user_id = Init.user_auth_id;
        data.series_id = Init.series_id;
        data.app_version = Init.app_version;
        data.app_role = Init.app_role;
        data.referrer = document.referrer;
        data.builder_uri = window.location.pathname + window.location.search;

        $.ajax({
            type: 'POST',
            url: '/data/submitAppData',
            dataType: 'json',
            data: data
        });

    };


    /** **************************************************************
     *                                   GETTERS - SETTERS
     */

}

export {UserData}

